import { Config, Register } from "@cleeng/mediastore-sdk";
import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { PUBLISHER_ID } from "../../../constants";
import { setExpiringItem, getExpiringItem, removeExpiringItem } from "../../../utils";

function RegisterPage() {
  Config.setPublisher(PUBLISHER_ID);
  const navigate = useNavigate();
  const { search } = useLocation();
  const query = new URLSearchParams(search);
  const offerId = query.get("offerId");
  const couponCode = query.get("couponCode");
  // Detect if user is coming from the app via ?fromApp=true and persist in localStorage
  const fromAppParam = query.get("fromApp");
  React.useEffect(() => {
    if (fromAppParam === "true") {
      setExpiringItem("fromApp", true); // 2 hours default
    } else if (fromAppParam === "false") {
      removeExpiringItem("fromApp");
    }
  }, [fromAppParam]);
  const fromApp = getExpiringItem("fromApp") === true;

  const handleNavigatePayment = () => {
    if (couponCode && offerId) {
      navigate(`/capture?offerId=${offerId}&couponCode=${couponCode}`)
    } else {
      navigate(`/capture`)
    };
  };

  const handleNavigateLogin = () => {
    navigate(`/`)
  };
  return (
    fromApp ? (
      <div className="from-app-text">
        <p>
          You've navigated to this page from a mobile application. If you wish to subscribe, please do so through that app store. To manage a subscription that was purchased through the web application, see <a href="/my-account?fromApp=true">account management</a>.
        </p>
      </div>
    ) : (
      <Register
        onSuccess={handleNavigatePayment}
        onHaveAccountClick={handleNavigateLogin}
      />
    )
  );
}

export default RegisterPage;
